import { render, staticRenderFns } from "./CrearMovimiento.vue?vue&type=template&id=9a0b29d0&scoped=true&"
import script from "./CrearMovimiento.vue?vue&type=script&lang=ts&"
export * from "./CrearMovimiento.vue?vue&type=script&lang=ts&"
import style0 from "./CrearMovimiento.vue?vue&type=style&index=0&id=9a0b29d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0b29d0",
  null
  
)

export default component.exports